import { ChoiceCard } from "portal/components/categoryCollectionProfile/ChoiceCard";
import { CreateCategoryDialogActions } from "./CreateCategoryDialogActions";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/AddOutlined";
import CategoryTemplatesIcon from "@mui/icons-material/CollectionsBookmarkOutlined";
import React, { FC } from "react";

export const CHOICE_NEW = "new";
export const CHOICE_TEMPLATE = "template";
export type CreateCategoryChoice = typeof CHOICE_NEW | typeof CHOICE_TEMPLATE;

type CreateCategoryChooseStepProps = {
  onCancel: () => void;
  onNext: (choice: CreateCategoryChoice) => void;
};

export const CreateCategoryChooseStep: FC<CreateCategoryChooseStepProps> = ({
  onCancel,
  onNext,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex flex-col gap-3">
        <ChoiceCard
          icon={<CategoryTemplatesIcon fontSize="small" />}
          label={t(
            "components.categoryCollectionProfile.actions.copyFromTemplate"
          )}
          description={t(
            "components.categoryCollectionProfile.actions.copyFromTemplateDetail"
          )}
          onClick={() => onNext(CHOICE_TEMPLATE)}
        />
        <ChoiceCard
          icon={<AddIcon fontSize="small" />}
          label={t(
            "components.categoryCollectionProfile.actions.createNewCategory"
          )}
          description={t(
            "components.categoryCollectionProfile.actions.createNewCategoryDetail"
          )}
          onClick={() => onNext(CHOICE_NEW)}
        />
      </div>
      <CreateCategoryDialogActions onCancel={onCancel} />
    </>
  );
};
